module.exports = __webpack_public_path__ + "static/WEDDING E&M-427-fd98c122f6067d16df2a02b606f00dfb.jpg";